export default [
    {
        path: 'relatorio-paciente-atendimento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-paciente-atendimento' */
            '@/views/ambulatorio/relatorio-paciente-atendimento/Index'
        ),
        redirect: 'relatorio-paciente-atendimento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-paciente-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-paciente-atendimento' */
                    '@/views/ambulatorio/relatorio-paciente-atendimento/List.vue'
                ),
            },
        ],
    },
]